let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c8f5t")).then(() => parcelRequire('6z8GT'));